"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
function default_1() {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "top_row subtitle3 gray-80" }, { children: t('내용') })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "top_row subtitle3 gray-80" }, { children: t('금액') })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "top_row subtitle3 gray-80" }, { children: t('송금 사진') }))] }));
}
exports.default = default_1;
